/**
 * Article page: build "On this page" links from h2 headings in article content.
 * Generates IDs for headings that don't have them and creates jump navigation.
 */
function buildArticleJumpNav() {
  const list = document.querySelector('[data-article-jump-nav-list]');
  if (!list) return;

  const section = list.closest('.shopify-section');
  if (!section) return;

  // Find article content - look for common article content containers
  const articleContent = section.querySelector('.blog-post-content, .article-content, .rte, [data-article-content]');
  if (!articleContent) return;

  list.innerHTML = '';

  // Find all h2 headings in the article content (h3s excluded from TOC)
  const headings = articleContent.querySelectorAll('h2');
  if (headings.length === 0) {
    // Hide the TOC panel if no headings found
    const tocPanel = list.closest('.article-sidebar__panel--toc');
    if (tocPanel) {
      tocPanel.style.display = 'none';
    }
    return;
  }

  const seen = new Set();
  let idCounter = 0;

  for (const heading of headings) {
    // Generate or use existing ID
    let id = heading.id;
    if (!id) {
      // Generate ID from heading text
      const text = heading.textContent.replace(/\s+/g, ' ').trim();
      id = text
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .substring(0, 50);

      // Ensure uniqueness
      let uniqueId = id || `heading-${idCounter}`;
      while (seen.has(uniqueId)) {
        idCounter++;
        uniqueId = `${id}-${idCounter}`;
      }
      id = uniqueId;
      heading.id = id;
    }

    if (seen.has(id)) continue;
    seen.add(id);

    // Add scroll-margin for sticky header offset
    heading.style.scrollMarginTop = 'var(--sticky-header-offset, 6rem)';

    const label = heading.textContent.replace(/\s+/g, ' ').trim();
    const level = heading.tagName.toLowerCase() === 'h3' ? '3' : '2';

    const li = document.createElement('li');
    li.setAttribute('data-level', level);

    const a = document.createElement('a');
    a.href = `#${id}`;
    a.textContent = label;

    li.appendChild(a);
    list.appendChild(li);
  }
}

// Build on initial load
buildArticleJumpNav();

// Rebuild on Shopify section load (for theme editor)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target?.querySelector?.('[data-article-jump-nav-list]')) {
    buildArticleJumpNav();
  }
});
